module.exports = __webpack_public_path__ + "img/hq_logo.809580f9.png";